"use strict";
var RefundedPaymentSummary = (function () {
    function RefundedPaymentSummary() {
    }
    return RefundedPaymentSummary;
}());
exports.RefundedPaymentSummary = RefundedPaymentSummary;
//# sourceMappingURL=D:/a/1/s/edit/src/models/refunded-payment-summary.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/models/refunded-payment-summary.model.js